import React from 'react';
import { List, Datagrid, TextField, NumberField, DateField, EditButton, Filter, SearchInput, SimpleList, ImageField } from 'react-admin';
import { useMediaQuery } from '@material-ui/core';

const ProductGroupFilter = (props: any) => (
    <Filter {...props} variant="outlined">
        <SearchInput label="Design Code" source="designCode~like" alwaysOn />
        <SearchInput label="Design Name" source="designName~like" alwaysOn />
    </Filter>
);

export const ProductGroupList = (props: any) => {
    const propsObj: any = { ...props };
    const isSmall = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));

    if (propsObj.permissions) {
        const resourcename = `/${props.resource}`;
        const myPermissions = propsObj.permissions.filter((item: any) => item.NavigateUrl.toLowerCase().trim() === resourcename);
        if (myPermissions.length > 0) {
            const p = myPermissions[0];
            propsObj.hasList = p.View === 1;
            propsObj.hasShow = p.View === 1;
            propsObj.hasEdit = p.Edit === 1;
            propsObj.hasDelete = p.Delete === 1;
            propsObj.hasCreate = p.Create === 1;
            propsObj.hasExport = p.Export === 1;
        }
    }

    return (
        <React.Fragment>
            <List
                {...propsObj}
                exporter={propsObj.hasExport}
                bulkActionButtons={false}
                title="Product Groups"
                filters={<ProductGroupFilter />}
            >
                {isSmall ? (
                    <SimpleList
                        primaryText={(record: any) => `${record.designCode || ''} - ${record.designName || ''}`}
                        secondaryText={(record: any) =>
                            record.cartonCapacity != null
                                ? `Carton Capacity: ${record.cartonCapacity}`
                                : ''
                        }
                        // tertiaryText={(record: any) =>
                        //     record.createdDate ? `Created: ${new Date(record.createdDate).toLocaleDateString()}` : ''
                        // }
                        linkType={propsObj.hasEdit ? 'edit' : 'show'}
                    />
                ) : (
                    <Datagrid rowClick={propsObj.hasEdit ? 'edit' : undefined}>
                        {propsObj.hasEdit && <EditButton />}
                        <ImageField source="photograph" label="Image" title="designName" sortable={false} />
                        <TextField source="designCode" label="Design Code" />
                        <TextField source="designName" label="Design Name" />
                        <NumberField source="cartonCapacity" label="Carton Capacity" />
                        {/* <DateField source="createdDate" label="Created Date" locales="fr-FR" />
                        <DateField source="modifyDate" label="Updated Date" locales="fr-FR" /> */}
                    </Datagrid>
                )}
            </List>
        </React.Fragment>
    );
};
